export interface BBoxRect {
  x: number;
  y: number;
  w: number;
  h: number;
}

export interface BBoxLayer {
  rowId: number;
  label: string;
  rects: BBoxRect[];
}

export interface AnnotatorRegion {
  type?: 'box';
  cls?: string;
  x: number;
  y: number;
  w: number;
  h: number;
  id?: string;
}

export const NON_INTERSECTING_LAYERS = new Set([
  'scanning',
  'staging',
  'packing',
]);

export const BBOX_COLORS = [
  '#2563EB', // blue
  '#DC2626', // red
  '#16A34A', // green
  '#D97706', // amber
  '#7C3AED', // violet
  '#DB2777', // pink
  '#0891B2', // cyan
  '#4F46E5', // indigo
];
